import createComponentPreset from "../../../../../fabrics/createComponentPreset";
import { createDisplayNameForMediaElement } from "../../../utils/getDisplayName";
import { createTestIdForMediaElement } from "../../../utils/getTestId";
import Addon from "../Addon/MediaAddon";

import classes from "./MediaCenterAddon.styl";

const CENTER_ADDON_DISPLAY_NAME = "CenterAddon";
const CENTER_ADDON_TEST_ID = createTestIdForMediaElement(
    CENTER_ADDON_DISPLAY_NAME,
);

/**
 * @deprecated
 * Используйте вместо этого компонента UniBoxAdditional / UniBoxMain
 */
export const CenterAddon = createComponentPreset(
    CENTER_ADDON_DISPLAY_NAME,
    Addon,
    {
        className: classes.addon,
        "data-tsid": CENTER_ADDON_TEST_ID,
    },
);

CenterAddon.displayName = createDisplayNameForMediaElement(
    CENTER_ADDON_DISPLAY_NAME,
);

export default CenterAddon;
